export const SCREEN_NAME_CATEGORY = {
    GIFTING: "gifting-checkout",
    QUICK_CHECKOUT: "quick-checkout",
};
